import fr from './fr';
import en from './en';

const translations = { fr, en };

let currentLang = localStorage.getItem('soul_valise_lang') || 'fr';

export const setLanguage = (lang) => {
  currentLang = lang;
  localStorage.setItem('soul_valise_lang', lang);
  window.dispatchEvent(new Event('languagechange'));
};

export const getLanguage = () => currentLang;

export const t = (key) => {
  const keys = key.split('.');
  let value = translations[currentLang];
  for (const k of keys) {
    if (!value) return key;
    value = value[k];
  }
  return value || key;
};

export const availableLanguages = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export default translations;
